//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapState } from 'vuex'
import searchUtils from '~/mixins/search/search-utils'

export default {
  name: 'SearchTitle',
  mixins: [searchUtils],
  computed: {
    ...mapState({
      location: state => state.search.locationFull
    }),
    ...mapGetters({
      searchTerms: 'search/searchTerms',
      lang: 'lang/locale'
    })
  }
}
